import * as React from 'react';
import './header.scss';
import { LOGOS } from '../utils/consts';

function Header({ isMenuActive, toggleHeaderMenu }) {
  return (
    <header className='content flex justify-between items-center py-6'>
      <img
        src={LOGOS.logoTextMobile}
        className='h-16 object-contain z-10'
        alt='Logo'
      />
      <button
        className='h-16 w-16 z-10'
        onClick={toggleHeaderMenu}
        role='button'
      >
        <img
          src={LOGOS.logotip}
          className='h-16 w-16 object-contain'
          alt='Logo'
        />
      </button>
    </header>
  );
}

export default Header;
